const $window = $(window);

// get the current position pf the scroll bar
// this is used to determine the scroll direction
let lastScrollValue = $window.scrollTop();

/**
 *  Check if large breakpoints
 *  @returns {boolean} - current breakpoint is desktop
 */
export const isDesktop = () => {
    if ($window.width() > 768) {
        return true;
    }
    return false;
};

/**
 *  Check if script is loaded
 *  @param {string} url - url of script
 *  @returns {boolean} - script is loaded
 */
export const isScriptLoaded = (url) => {
    if (url) {
        const scripts = document.getElementsByTagName("script");
        for (let i = scripts.length - 1; i >= 0; i--) {
            if (scripts[i].src === url) {
                return true;
            }
        }
    }

    return false;
};

/**
* Returns the scroll direction of the window
* @returns {string} - "up" or "down"
*/
export const getScrollDirection = () => {
    const newScrollValue = $window.scrollTop();

    if (newScrollValue > lastScrollValue) {
        lastScrollValue = newScrollValue;
        return "down";
    }

    lastScrollValue = newScrollValue;
    return "up";
};
